import { useState, useCallback, useMemo } from 'react';
import Api from '../../../../../component/Api';
import { toast } from 'react-toastify';

export const useDownload = (filters = {}) => {
    const { http } = useMemo(() => Api(), []);
    const [isDownloading, setIsDownloading] = useState(false);

    const handleDownload = useCallback(async () => {
        try {
            setIsDownloading(true);
            const response = await http.get(`/is/evaluationListPdf`, {
                params: {
                    search: filters.search || '',
                    course: filters.course || '',
                    discipline: filters.discipline || '',
                    status: filters.status || '',
                },
                responseType: 'blob',
            });

            const contentType = response.headers['content-type'];
            if (contentType && contentType.includes('application/json')) {
                const errorText = await response.data.text();
                const errorJson = JSON.parse(errorText);
                throw new Error(errorJson.message || 'Something went wrong');
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Student_List.pdf');
            document.body.appendChild(link);
            link.click();

            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            toast.success('Downloaded successfully');
        } catch (error) {
            console.error('Error fetching PDF:', error);
            if (error.response && error.response.data instanceof Blob) {
                const errorText = await error.response.data.text();
                try {
                    const errorJson = JSON.parse(errorText);
                    toast.error(errorJson.message || 'Failed to download PDF');
                } catch {
                    toast.error('Failed to download PDF');
                }
            } else {
                toast.error(error.message || 'Failed to download PDF');
            }
        } finally {
            setIsDownloading(false);
        }
    }, [http, filters]);

    return { isDownloading, handleDownload };
};